import Form from '../../views/Prova/Form';
import { __ADMINISTRADOR, __CENTRAL } from '../../security/RoleConfiguration';

export const path = '/admin/provas';

export const listRoutes = [
    {
        path: `${path}/adicionar`,
        component: Form,
        roles: [ __ADMINISTRADOR, __CENTRAL],
    },
]

export default listRoutes;